<template>
  <v-row id="how-it-works" class="features-section py-12" no-gutters>
    <div class="background-overlay"></div>
    <v-container class="position-relative">
      <v-row>
        <v-col cols="12" class="text-center mb-8">
          <h2 class="typography-h3 weight-bold">{{ $t('howItWorks.title') }}</h2>
          <p class="typography-subtitle-1 text-muted mt-2">{{ $t('howItWorks.subtitle') }}</p>
        </v-col>
      </v-row>

      <v-row class="mt-4">
        <v-col
          v-for="(feature, key) in features"
          :key="key"
          cols="12"
          sm="6"
          md="4"
          class="d-flex"
        >
          <v-card class="feature-card card-standard" elevation="0">
            <v-card-item>
              <v-icon
                size="48"
                color="primary"
                class="mb-4"
              >
                {{ feature.icon }}
              </v-icon>
              <h3 class="typography-h5 weight-bold mb-2">{{ $t(`howItWorks.features.${key}.title`) }}</h3>
              <p class="typography-body text-medium-emphasis">{{ $t(`howItWorks.features.${key}.description`) }}</p>
            </v-card-item>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-row>
</template>

<script setup>
const features = {
  aiAnalysis: {
    icon: 'mdi-shield-check'
  },
  roomEvaluation: {
    icon: 'mdi-floor-plan'
  },
  costEfficiency: {
    icon: 'mdi-chart-bar'
  },
  accessibility: {
    icon: 'mdi-account-check'
  },
  recommendations: {
    icon: 'mdi-lightbulb'
  },
  inspiration: {
    icon: 'mdi-compare'
  }
};
</script>

<style scoped>
.features-section {
  position: relative;
  background: var(--background);
  color: var(--text-primary);
  padding: 5rem 0;
}

.feature-card {
  height: 100%;
  padding: 2rem;
}

:deep(.v-card-item) {
  padding: 0;
}

.v-icon {
  color: var(--primary) !important;
  opacity: 0.9;
  margin-bottom: 1.5rem;
}

.how-it-works-section {
  padding: 4rem 0;
  background: var(--background);
}

@media (max-width: 600px) {
  .how-it-works-section {
    padding: 2rem 0;
  }
}
</style>
